import React from "react";
import { CLOSE_ICON } from "../../utils/aap-image-constant";
import { useTranslation } from "react-i18next";

const Modal = ({
  modalId = "defaultModalId",
  buttonLable = "",
  cancelLable = "",
  modalClick = null,
  title = "",
  onOkClick = "",
  children,
  heading = "",
  className = "",
  logoutimg = "",
  iconsrc = "",
  titleclass = "",
  modalfooter = "",
  modalContentClass = "",
  paragraph = "",
  modalheader = "",
  paragraphclassName = "",
  closebtnclass = "",
  modalbody = "",
  secondpara="",
  headingClass="",
  secondparaclassName="",
  strongText="",
  btnclass="",
  navigatebtn="",
  onNavigateClick="",
  handleModalClose = function o() { },
  handleClick = function o() { },
}) => {
  const { t } = useTranslation();

  return (
    <div className="emp-model">
      <button
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target={`#${modalId}`}
        ref={modalClick}
      ></button>

      <div
        className="modal fade custom-modal-backdrop"
        id={modalId}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby={`${modalId}Label`}
        aria-hidden="true"
      >
        <div className={`modal-dialog modal-dialog-centered ${className}`}>
          <div className="modal-content">
            <div className={`${modalContentClass}`}>
              <div className={`modal-header ${modalheader}`}>
                <button
                  type="button"
                  className={`btn btnclose closebtn ${closebtnclass}`}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleModalClose}
                >
                  <img src={CLOSE_ICON} alt="close" className="closeicon" />
                </button>
                <h5 className={`modal-title ${titleclass}`} id={`${modalId}Label`}>
                  {title}
                </h5>
              </div>

              <div className={`modal-body ${modalContentClass} ${modalbody}`}>
                {iconsrc && (
                  <img
                    src={iconsrc}
                    alt="icon"
                    className={`modelsuccessimg mb-2 ${logoutimg}`}
                  />
                )}
                <h2 className={`tableheading fs-22  fw-600 ${headingClass}`}>{t(heading)}</h2>
                {children}
                <p className={`paragraphtext fs-12 ${paragraphclassName}`}>
                  {paragraph} <br/> <strong>{strongText}</strong>
                </p>
                <p className={`paragraphtext fs-12 ${secondparaclassName}`}>
                  {secondpara}
                </p>
              </div>

              <div className={`modal-footer modal-footer justify-content-center ${modalfooter}`}>
                {cancelLable && (
                  <button
                    type="button"
                    className="btn  cancelbtn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    {t(cancelLable)}
                  </button>
                )}
                {buttonLable && (
                  <button
                    type="button"
                    className={` ${btnclass} btn btn-danger`}
                    onClick={onOkClick}
                  >
                    {t(buttonLable)}
                  </button>
                )}
                {navigatebtn && (
                  <button
                    type="button"
                    className={` ${btnclass}`}
                    data-bs-dismiss="modal"
                    onClick={onNavigateClick}
                  >
                    {t(navigatebtn)}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
